import { ElementFragmentFragment } from "src/graphql/anti-fraud/__generated__/graphql";
import { Element } from "src/types/element";

import { mapIdentifier } from "./identifier.mapper";
import { mapToPropertyValue } from "./property.mappers";

export const mapToElement = (fragment: ElementFragmentFragment): Element => ({
  id: fragment.id,
  name: fragment.name,
  typeCode: fragment.typeCode,
  configurableType: {
    code: fragment.configurableType.code,
    name: fragment.configurableType.name,
  },
  schemaElement: {
    code: fragment.schemaElement.code,
    name: fragment.schemaElement.name,
  },
  properties: fragment.properties.map(mapToPropertyValue),
  identifiers: fragment.identifiers.map(mapIdentifier),
  elements: fragment.elements.map((element) => ({
    id: element.id,
    typeCode: element.typeCode,
    configurableType: {
      code: element.configurableType.code,
      name: element.configurableType.name,
    },
    schemaElement: element.schemaElement
      ? { code: element.schemaElement.code, name: element.schemaElement.name }
      : undefined,
    name: element.name,
    properties: element.properties.map(mapToPropertyValue),
  })),
});
